import { IBrandViewV2Response } from "@faire/web-api/indigofair/data/IBrandViewV2Response";
import { use } from "react";

import { useBrandPageBrandViewContext } from "../contexts/BrandPageBrandViewContext";

export const useBrandView = (): IBrandViewV2Response | undefined => {
  const { brandViewLegacy, brandViewPromise } = useBrandPageBrandViewContext();

  if (brandViewPromise) {
    return use(brandViewPromise);
  }
  return brandViewLegacy;
};
